export default {
  siteUnitEvents: state => state.siteUnitEvents,
  errors: state => state.errors
};
